import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

export { asyncRoutes } from './async-routes'

Vue.use(VueRouter)

/**
 * Constant route.
 *
 * Rute ini akan tersedia untuk semua pengguna.
 */
export const constantRoutes: Array<RouteConfig> = [
  {
    path: '/license',
    name: 'LicenseView',
    component: () => import('@/design/license/index.vue'),
    meta: { title: 'License' },
  },

  // {
  //   path: '/v/:uid/:slug',
  //   name: 'View',
  //   component: () => import('@/design/Runtime sau/Index.vue'),
  //   meta: { title: 'Runtime' },
  // },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/design/Login/Login.vue'),
  },
  {
    path: '/404',
    name: 'notFound',
    component: () => import('@/design/Error/error-404.vue'),
  },
  {
    path: '/500',
    name: 'serverError',
    component: () => import('@/design/Error/error-500.vue'),
  },
]

const createRouter = () =>
  new VueRouter({
    mode: 'history', // require service support
    // scrollBehavior: () => ({ y: 0 }),
    base: process.env.BASE_URL,
    routes: constantRoutes,
    linkActiveClass: 'active',
  })

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
    // eslint-disable-next-line
  ;(router as any).matcher = (newRouter as any).matcher
}
export default router
